import React, { Component } from 'react';
import { Link } from 'react-router';
import $ from 'jquery';
import Swiper from 'react-id-swiper';
import ReactSwipe from 'react-swipe';

const baseUrl='https://aquadeals.in/admin/web3/user/';
const baseAssets = 'https://aquadeals.in/admin/assets/';

export default class PromotionsNew extends Component{
	constructor(props){
		super(props);
		this.state={
			tot_data:[],
			product_offers:[],
			seed_offers:[],
			offers:[],
			is_loading: false,
		}
		this.getOffers=this.getOffers.bind(this);
	}
	componentDidMount()
	{
		this.getOffers();
	}
	getOffers()
	{
		var data1={from:'mobile_web'};
		var data2=JSON.stringify(data1);
		$.ajax({
			method:'POST',
			dataType:'json',
			data:{req:data2},
			url:baseUrl+'getOffers',
			success:function(data)
			{
				if(data.status==='available')
				{
					this.setState({
						tot_data:data,
						product_offers:data.product_offers,
						seed_offers:data.seed_offers,
						offers:data.offers,
						is_loading: true
					});
					setTimeout(function(){ $('.promo_truck_img').show(); }, 100);
				}
			}.bind(this),
			error:function(err)
			{
			}
		});
	}
	render()
	{
		const params = {
	      paginationClickable: true,
	      spaceBetween: 0,
	      slidesPerView: 1,
	      // autoplay:3000,
	      // autoplayDisableOnInteraction:false,
	      // loop:true
	      parallax: true,
	      parallaxEl: {
	        el: '.parallax-bg',
	        value: '-23%'
	      },
	    }
	    
		var product_offers = this.state.product_offers.map(function(product, index) {
	      return (
	        	<Link className={"new_promo_item promo_road_img2"} to={"/pdetails/"+product.url_dtype_name+"/"+product.url_cat_name+"/"+product.url_brand_name+"/"+product.url_product_name+"/"+product.product_id+"/"+product.deal_id} >
	        	{/*<Link className={"new_promo_item promo_road_img2 promo_road_img_"+index} to={"/pdetails/"+product.url_dtype_name+"/"+product.url_cat_name+"/"+product.url_brand_name+"/"+product.url_product_name+"/"+product.product_id+"/"+product.deal_id} >*/}
		            <div className="promo_swipe_img">
		            <div className="raod_img"> <img className="img" src="https://aquadeals.in/admin/assets/images/web_imgs/road_0.png" alt="" title="" />
 <span className="promo_swipe_img_item">
 <img src={product.img=== '' ? baseAssets+'icons/web_icons/offer-icon.png' : product.img} alt="" />
 </span>
		             </div>
	                   <div className="btm_swp">
	                    {product.title ? <h5 className="promo_gen_title">{product.title}</h5> : <h5 className="promo_gen_title">&nbsp;</h5>}
	                    {product.desc ? <h6 className="gen_desc">{product.desc}</h6> : <h6 className="gen_desc">&nbsp;</h6>}
	                    </div>
	                </div>
		        </Link>
	      	)
	    });
	    var seed_offers = this.state.seed_offers.map(function(seed, index) {
	        return (
	          	<Link className={"new_promo_item promo_road_img2"} to={"/sdetails/"+seed.url_title+"/"+seed.deal_id}>
	          	{/*<Link className={"new_promo_item promo_road_img2 promo_road_img_"+index} to={"/sdetails/"+seed.url_title+"/"+seed.deal_id}>*/}
	                <div className="promo_swipe_img">
	                 <div className="raod_img"> <img className="img" src="https://aquadeals.in/admin/assets/images/web_imgs/road_0.png" alt="" title="" />
	                    <span className="promo_swipe_img_item"><img src={seed.img=== '' ? baseAssets+'icons/web_icons/offer-icon.png' : seed.img} alt="" /></span>
	                   	</div>
	                   	<div className="btm_swp">
	                    {seed.title ? <h5 className="promo_gen_title">{seed.title}</h5> : <h5 className="promo_gen_title">&nbsp;</h5>}
	                    {seed.desc ? <h6 className="gen_desc">{seed.desc}</h6> : <h6 className="gen_desc">&nbsp;</h6>}
	                    </div>
	                </div>
	            </Link>
	        )
	    });  
	    var offers = this.state.offers.map(function(offer, index) {
	        return (
	          	<Link className={"new_promo_item promo_road_img2 promo_road_img_"+index} to={'/offer/'+offer.id+"/details"}> 
	          	{/*<Link className={"new_promo_item promo_road_img2 promo_road_img_"+index} to={'/offer/'+offer.id+"/details"}> */}
	                <div className="promo_swipe_img">
	                 <div className="raod_img"> <img className="img" src="https://aquadeals.in/admin/assets/images/web_imgs/road_0.png" alt="" title="" />
	                    <span className="promo_swipe_img_item"><img src={offer.img=== '' ? baseAssets+'icons/web_icons/offer-icon.png' : offer.img} alt="" /></span>
	                   	</div>
	                   	<div className="btm_swp">
	                    {offer.title ? <h5 className="promo_gen_title">{offer.title}</h5> : <h5 className="promo_gen_title">&nbsp;</h5>}
	                    {offer.desc ? <h6 className="gen_desc">{offer.desc}</h6> : <h6 className="gen_desc">&nbsp;</h6>}
	                    </div>
	                </div>      
	            </Link>
	          )
	    });
	    $('body').css('background-color','#fff');
		return(
			<div>
			{this.state.is_loading ? 	
			<div className="promotional_blk container-fluid" style={{textAlign:'center'}}>
				<div style={{marginBottom:'15px'}}>
					<div>
						{/*<div className="promo_truck_img">
						<div className="truck_img"><img src="https://aquadeals.in/admin/assets/images/web_imgs/promotions_truck.png" alt="" title="" /> </div>
							<Swiper {...params} key={product_offers.length + seed_offers.length + offers.length}>
								{product_offers}
								{seed_offers}
								{offers}
							</Swiper>						
						</div>*/}
						<div className="truck_img"><img src="https://aquadeals.in/admin/assets/images/web_imgs/promotions_truck.png" alt="" title="" /> </div>
							<ReactSwipe ref="reactSwipe" className="carousel item" swipeOptions={{
									continuous: true,
									disableScroll:  (product_offers.length + seed_offers.length + offers.length) === 1 ? true : false,
									stopPropagation: false,
									callback: function(index, elem) {},
									transitionEnd: function(index, elem) {}
							}} key={product_offers.length + seed_offers.length + offers.length}>
									{product_offers}
									{seed_offers}
									{offers}
							</ReactSwipe>	
					</div>
					<div className="row promo_titles_blk">
						<div className="col-lg-6 col-md-6 col-sm-6 col-xs-6" >
							<h5 className="promotions_title">{this.state.offers.length > 0 ? 'AD OFFERS' : 'PROMOTIONS'}</h5>
						</div>
						<div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 promotions_viewall_title">
							<a className="promo_view_all" href={this.state.offers.length > 0 ? "/offerszone" : "/promotional_offers"}>VIEW ALL</a>
						</div>
					</div>
				</div>
			</div>
			: "" }
			</div>
		);
	}
}


/** WEBPACK FOOTER **
 ** ./src/components/Categories/Promotions/PromotionsNew.js
 **/